import { Observable } from 'rxjs';

export abstract class StorageAbstract {
  abstract get(key: string): Promise<any>;
  abstract watch(key: string): Observable<any>;
  abstract set(key: string, value: any): Promise<void>;
  abstract remove(key: string): Promise<void>;
  abstract clear(): Promise<void>;
}
